// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y4LuHREMh7_sjzO7dTYH {
  background-color: #f7f7f7;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 100%;
}

.y4LuHREMh7_sjzO7dTYH .DwW6872Uvq8l1fIJ8qaE {
  background-color: #ffffff;
  border: 1px none;
  position: relative;
  width: 360px;
}

.y4LuHREMh7_sjzO7dTYH .Cw7FvztuUvs5MBrNGqIy {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 50px;
}

.y4LuHREMh7_sjzO7dTYH .pPJxI51PzkODqVgA7tX0 {
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 2px;
  position: relative;
  width: 322px;
  margin-top: 25px;
}

.y4LuHREMh7_sjzO7dTYH .tC5CgMoDcLqj9t1nf5NO {
  align-self: stretch;
  color: #333333;
  font-family: "Open Sans-Regular", Helvetica;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -1px;
  position: relative;
}

.y4LuHREMh7_sjzO7dTYH ._zQ2d_8nDeXscSMNAf13 {
  align-self: stretch;
  color: #333333;
  font-family: "Open Sans-Bold", Helvetica;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
}

.y4LuHREMh7_sjzO7dTYH .ICWM_e7Ko3ap0U1ZN2HQ {
  align-items: center;
  align-self: stretch;
  background-color: #ffffff;
  border: 1px solid;
  border-color: #d8d8d8;
  border-radius: 8px;
  display: flex;
  flex: 0 0 auto;
  padding: 15px 16px;
  position: relative;
  margin-bottom: 30px;
  box-shadow: 0px 26px 30px 0px rgba(0, 0, 0, 0.05);
}

@media only screen and (max-width: 600px) {
  .ICWM_e7Ko3ap0U1ZN2HQ {
    flex-direction: column;
  }
}

.y4LuHREMh7_sjzO7dTYH .fXD7rbIlFwe4_qSC_ToY {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-grow: 1;
  gap: 2px;
  position: relative;
}

.y4LuHREMh7_sjzO7dTYH .qfzcQnXAzXF4mxmc2y5p {
  align-self: stretch;
  color: #333333;
  font-family: "Open Sans-Bold", Helvetica;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -1px;
  position: relative;
}

.y4LuHREMh7_sjzO7dTYH .ByNc0cx9OFAqzptoC4v9 {
  align-self: stretch;
  color: #333333;
  font-family: "Open Sans-Regular", Helvetica;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin: 0;
  position: relative;
}

.y4LuHREMh7_sjzO7dTYH .XZRs71UxNAese1hkQaQk {
  align-items: flex-start;
  background-color: #ed1b2e;
  border-radius: 100px;
  display: inline-flex;
  gap: 10px;
  justify-content: center;
  padding: 10px 16px 11px;
  position: relative;
  cursor: pointer;
}

.y4LuHREMh7_sjzO7dTYH .RKIUgj9sCgP_ggaQMS7K {
  color: #ffffff;
  font-family: "Open Sans-Bold", Helvetica;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -1px;
  position: relative;
  width: fit-content;
}

.y4LuHREMh7_sjzO7dTYH .A6VZlyf2q8aa1Pnbp7h5 {
  height: 13.06px;
  margin-right: -1.06px;
  position: relative;
  width: 7.59px;
}

.y4LuHREMh7_sjzO7dTYH .eNjVkgWfzjcD80fGcPdV {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 16px;
  position: relative;
  overflow: auto;
}

.y4LuHREMh7_sjzO7dTYH .zWhf2dr3t0QmPv7xQuYg {
  align-self: stretch;
  color: #333333;
  font-family: "Open Sans-Bold", Helvetica;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.6px;
  line-height: normal;
  position: relative;
}

.y4LuHREMh7_sjzO7dTYH .tJsYgHlGkCi8NldER931 {
  align-items: flex-start;
  align-self: stretch;
  flex-wrap: wrap;
  display: flex;
  flex: 0 0 auto;
  gap: 16px;
  position: relative;
}

@media only screen and (max-width: 600px) {
  .tJsYgHlGkCi8NldER931 {
    flex-direction: column;
  }
}

.y4LuHREMh7_sjzO7dTYH .W3zb8QOI7AM38X3IrjZ1 {
  align-self: stretch !important;
  flex: 0 0 auto !important;
  width: 100% !important;
}

.y4LuHREMh7_sjzO7dTYH .fhVVyqIy612g5ALqg7Oh {
  flex: unset !important;
  height: 16px !important;
}

.y4LuHREMh7_sjzO7dTYH .nRIkJ7c0G5mXpVigcjEt {
  height: 90px;
  left: 0;
  position: fixed;
  top: 0;
  width: 360px;
}

.y4LuHREMh7_sjzO7dTYH .sb7nwIglkb26pVYd_YHg {
  align-items: center;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px #2015150d;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  padding-left: 0;
  position: sticky;
  z-index: 9;
}

.y4LuHREMh7_sjzO7dTYH .H62PxxZXJ2kZN7Bfij0w {
  height: 25px;
  position: relative;
  width: 180px;
}

.y4LuHREMh7_sjzO7dTYH .KyztVBQMelDUDdPbxFtj {
  color: #ec2030;
  font-family: "Open Sans-Medium", Helvetica;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 18px;
  position: relative;
  width: fit-content;
  cursor: pointer;
}

.y4LuHREMh7_sjzO7dTYH .q6SLJ5R4zz98qfHLTgTN {
  height: 75px;
  left: 0;
  position: fixed;
  top: 961px;
  width: 360px;
}

.CTAyQHyY1HLRuaR5sB7s {
  align-self: center;
  align-items: flex-start;
  background-color: #ffffff;
  border-color: #0000001a;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: center;
  position: relative;
  width: 100%;
}

.Cf6D38lZgGCPGygS4oHr {
  color: #333333;
  font-family: "Noto Sans-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
  position: relative;
  height: 24px;
}

.CTAyQHyY1HLRuaR5sB7s .IS_9Ihhr6VfkSRffbBQI {
  align-self: stretch;
  color: #828282;
  flex: 1;
  font-family: "Open Sans-Regular", Helvetica;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
}

.e5gSWxnMOSqNfrubzIfk {
  height: 80px;
  width: 80px;
  flex-shrink: 0;
  border-radius: 8px 0 0 8px;
  object-fit: cover;
}

.RVrugEhB4WaTBKD7d4wr {
  align-items: flex-start;
  align-self: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-grow: 1;
  gap: 2px;
  padding: 16px;
  position: relative;
}

.MgK6nzlCUXVfjg2Z5sAZ {
  align-items: flex-start;
  align-self: stretch;
  flex-direction: row;
  display: flex;
  flex: 0 0 auto;
  gap: 2px;
  position: relative;
  font-family: "Open Sans-Bold", Helvetica;
  fontweight: 600;
  line-height: 28px;
  font-size: 16px;
}

.q7cDnHYxgLEbRfhvAN4m {
  color: #26c022;
  font-family: "Noto Sans-Bold", Helvetica;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/Home.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,eAAe;EACf,MAAM;EACN,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,OAAO;EACP,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB","sourcesContent":[".home {\n  background-color: #f7f7f7;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  height: 100%;\n}\n\n.home .div {\n  background-color: #ffffff;\n  border: 1px none;\n  position: relative;\n  width: 360px;\n}\n\n.home .home_content {\n  align-items: center;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 50px;\n}\n\n.home .welcome {\n  align-items: flex-start;\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 2px;\n  position: relative;\n  width: 322px;\n  margin-top: 25px;\n}\n\n.home .text_wrapper_2 {\n  align-self: stretch;\n  color: #333333;\n  font-family: \"Open Sans-Regular\", Helvetica;\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-top: -1px;\n  position: relative;\n}\n\n.home .username {\n  align-self: stretch;\n  color: #333333;\n  font-family: \"Open Sans-Bold\", Helvetica;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n}\n\n.home .riskprofile_div {\n  align-items: center;\n  align-self: stretch;\n  background-color: #ffffff;\n  border: 1px solid;\n  border-color: #d8d8d8;\n  border-radius: 8px;\n  display: flex;\n  flex: 0 0 auto;\n  padding: 15px 16px;\n  position: relative;\n  margin-bottom: 30px;\n  box-shadow: 0px 26px 30px 0px rgba(0, 0, 0, 0.05);\n}\n\n@media only screen and (max-width: 600px) {\n  .riskprofile_div {\n    flex-direction: column;\n  }\n}\n\n.home .riskprofile_txt {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  flex-grow: 1;\n  gap: 2px;\n  position: relative;\n}\n\n.home .text_wrapper_4 {\n  align-self: stretch;\n  color: #333333;\n  font-family: \"Open Sans-Bold\", Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-top: -1px;\n  position: relative;\n}\n\n.home .cari_tahu_kecocokan {\n  align-self: stretch;\n  color: #333333;\n  font-family: \"Open Sans-Regular\", Helvetica;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0;\n  position: relative;\n}\n\n.home .riskprofile_btn {\n  align-items: flex-start;\n  background-color: #ed1b2e;\n  border-radius: 100px;\n  display: inline-flex;\n  gap: 10px;\n  justify-content: center;\n  padding: 10px 16px 11px;\n  position: relative;\n  cursor: pointer;\n}\n\n.home .text_wrapper_5 {\n  color: #ffffff;\n  font-family: \"Open Sans-Bold\", Helvetica;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: normal;\n  margin-top: -1px;\n  position: relative;\n  width: fit-content;\n}\n\n.home .vector {\n  height: 13.06px;\n  margin-right: -1.06px;\n  position: relative;\n  width: 7.59px;\n}\n\n.home .produk_div {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 16px;\n  position: relative;\n  overflow: auto;\n}\n\n.home .ANDA_MEMILIKI {\n  align-self: stretch;\n  color: #333333;\n  font-family: \"Open Sans-Bold\", Helvetica;\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0.6px;\n  line-height: normal;\n  position: relative;\n}\n\n.home .produk_list {\n  align-items: flex-start;\n  align-self: stretch;\n  flex-wrap: wrap;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  position: relative;\n}\n\n@media only screen and (max-width: 600px) {\n  .produk_list {\n    flex-direction: column;\n  }\n}\n\n.home .frame_11 {\n  align-self: stretch !important;\n  flex: 0 0 auto !important;\n  width: 100% !important;\n}\n\n.home .frame_instance {\n  flex: unset !important;\n  height: 16px !important;\n}\n\n.home .IMG {\n  height: 90px;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 360px;\n}\n\n.home .home_nav {\n  align-items: center;\n  background-color: #ffffff;\n  box-shadow: 0px 4px 4px #2015150d;\n  display: flex;\n  justify-content: space-between;\n  padding: 16px;\n  padding-left: 0;\n  position: sticky;\n  z-index: 9;\n}\n\n.home .image {\n  height: 25px;\n  position: relative;\n  width: 180px;\n}\n\n.home .text_wrapper_6 {\n  color: #ec2030;\n  font-family: \"Open Sans-Medium\", Helvetica;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 18px;\n  position: relative;\n  width: fit-content;\n  cursor: pointer;\n}\n\n.home .img {\n  height: 75px;\n  left: 0;\n  position: fixed;\n  top: 961px;\n  width: 360px;\n}\n\n.produk {\n  align-self: center;\n  align-items: flex-start;\n  background-color: #ffffff;\n  border-color: #0000001a;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n}\n\n.nama_produk {\n  color: #333333;\n  font-family: \"Noto Sans-Regular\", Helvetica;\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 24px;\n  position: relative;\n  height: 24px;\n}\n\n.produk .nomor_polis {\n  align-self: stretch;\n  color: #828282;\n  flex: 1;\n  font-family: \"Open Sans-Regular\", Helvetica;\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: normal;\n  position: relative;\n}\n\n.rectangle {\n  height: 80px;\n  width: 80px;\n  flex-shrink: 0;\n  border-radius: 8px 0 0 8px;\n  object-fit: cover;\n}\n\n.div_polis {\n  align-items: flex-start;\n  align-self: center;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  flex-grow: 1;\n  gap: 2px;\n  padding: 16px;\n  position: relative;\n}\n\n.div_status {\n  align-items: flex-start;\n  align-self: stretch;\n  flex-direction: row;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 2px;\n  position: relative;\n  font-family: \"Open Sans-Bold\", Helvetica;\n  fontweight: 600;\n  line-height: 28px;\n  font-size: 16px;\n}\n\n.span_status {\n  color: #26c022;\n  font-family: \"Noto Sans-Bold\", Helvetica;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home": `y4LuHREMh7_sjzO7dTYH`,
	"div": `DwW6872Uvq8l1fIJ8qaE`,
	"home_content": `Cw7FvztuUvs5MBrNGqIy`,
	"welcome": `pPJxI51PzkODqVgA7tX0`,
	"text_wrapper_2": `tC5CgMoDcLqj9t1nf5NO`,
	"username": `_zQ2d_8nDeXscSMNAf13`,
	"riskprofile_div": `ICWM_e7Ko3ap0U1ZN2HQ`,
	"riskprofile_txt": `fXD7rbIlFwe4_qSC_ToY`,
	"text_wrapper_4": `qfzcQnXAzXF4mxmc2y5p`,
	"cari_tahu_kecocokan": `ByNc0cx9OFAqzptoC4v9`,
	"riskprofile_btn": `XZRs71UxNAese1hkQaQk`,
	"text_wrapper_5": `RKIUgj9sCgP_ggaQMS7K`,
	"vector": `A6VZlyf2q8aa1Pnbp7h5`,
	"produk_div": `eNjVkgWfzjcD80fGcPdV`,
	"ANDA_MEMILIKI": `zWhf2dr3t0QmPv7xQuYg`,
	"produk_list": `tJsYgHlGkCi8NldER931`,
	"frame_11": `W3zb8QOI7AM38X3IrjZ1`,
	"frame_instance": `fhVVyqIy612g5ALqg7Oh`,
	"IMG": `nRIkJ7c0G5mXpVigcjEt`,
	"home_nav": `sb7nwIglkb26pVYd_YHg`,
	"image": `H62PxxZXJ2kZN7Bfij0w`,
	"text_wrapper_6": `KyztVBQMelDUDdPbxFtj`,
	"img": `q6SLJ5R4zz98qfHLTgTN`,
	"produk": `CTAyQHyY1HLRuaR5sB7s`,
	"nama_produk": `Cf6D38lZgGCPGygS4oHr`,
	"nomor_polis": `IS_9Ihhr6VfkSRffbBQI`,
	"rectangle": `e5gSWxnMOSqNfrubzIfk`,
	"div_polis": `RVrugEhB4WaTBKD7d4wr`,
	"div_status": `MgK6nzlCUXVfjg2Z5sAZ`,
	"span_status": `q7cDnHYxgLEbRfhvAN4m`
};
export default ___CSS_LOADER_EXPORT___;
